import { apiClient } from "@/courses/services/GenericService.js";
import { apiClient as apiClientV2 } from "./ApiClientV2.js";
import {
  getCurrentCourseUrl,
  courseCopyUrl,
  courseAdminOverviewAPIUrl,
  adminOverviewSearchUsersUrl,
  getInstructorsUrl,
  activateAllStudentsUrl,
  GRADE_SCHEME_ELEMENTS_API_V2_URLS,
} from "@/courses/urls.js";

export const importCourse = async (formData) => {
  const url = courseCopyUrl.stringify();
  const { status } = await apiClient.post(url, formData);
  return status;
};

export const searchCourses = async (params) => {
  const url = courseAdminOverviewAPIUrl.stringify();
  const { data } = await apiClientV2.get(url, { params: params });
  return data;
};

export const searchUsers = async (params) => {
  const url = adminOverviewSearchUsersUrl.stringify();
  const { data } = await apiClientV2.get(url, { params: params });
  return data;
};
export const searchInstructors = async (params) => {
  const url = getInstructorsUrl.stringify();
  const { data } = await apiClientV2.get(url, { params: params });
  return data;
};

export const activateAllStudents = async (courseId) => {
  const url = activateAllStudentsUrl.stringify({ courseId });
  const { data } = await apiClientV2.post(url);
  return data;
};

export const getCourse = async (courseId) => {
  const url = getCurrentCourseUrl.stringify({ courseId });
  const { data } = await apiClientV2.get(url);
  return data;
};

export const getGradeSchemeElements = async (courseId) => {
  const url = GRADE_SCHEME_ELEMENTS_API_V2_URLS.index.stringify({ courseId });
  const { data } = await apiClientV2.get(url);
  return data;
};

export const updateGradeSchemeElements = async (courseId, payload) => {
  const url = GRADE_SCHEME_ELEMENTS_API_V2_URLS.staffIndex.stringify({
    courseId,
  });
  const { data } = await apiClientV2.put(url, payload);
  return data;
};

export const deleteAllGradeSchemeElements = async (courseId) => {
  const url = GRADE_SCHEME_ELEMENTS_API_V2_URLS.destroyAll.stringify({
    courseId,
  });
  const { data } = await apiClientV2.delete(url);
  return data;
};
